<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Invoice note
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      div.d-flex.align-center
        div.text-sm.font-medium.neutral700--text Invoice note ({{ `#${invoice.rid}` }})
        v-spacer
        template(v-if="!editable")
          y-button(label="Remove" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="danger500" unset-min-width size="xxs" button-class="px-2" @click="notes = null; editable = true")
          y-button.ml-2(label="Edit" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="editable = true")
      v-textarea.round-xl.mt-2(v-model="notes" placeholder="Enter invoice note..." outlined hide-details rows="4" auto-grow :readonly="!editable")
    v-divider
    v-card-actions.py-3.px-4
      v-spacer
      y-button(label="Cancel" underline size="sm" unset-min-width @click="showDialog = false")
      y-button.ml-2(label="Save" size="sm" :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isLoading: false,
      editable: true,
      notes: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      leadPid: 'treatment/getLeadPid',
      invoice: 'treatment/getInvoice',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.invoice && this.invoice.notes) {
        this.notes = this.invoice.notes
        this.editable = false
      }
    },
    saveData () {
      this.isLoading = true
      const payload = { notes: this.notes }
      this.$axios.patch(`/invoices/${this.leadPid}`, payload)
        .then(() => {
          this.showDialog = false
          this.$emit('updated')
        })
        .catch((err) => {
          let message = this.$t('error_message.unable_to_complete_request')   
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
